module.exports = __webpack_public_path__ + "static/media/RRD3-BG1.085956f1.jpg";